import { BasicCard, Subtitle, Title } from '../BasicQuery.styles'

interface ProductInfoCardProps{
    description: string
    productCode: string
    idModel: string|number
  }

export const ProductInfoCard = ({ description, idModel, productCode }: ProductInfoCardProps) => (
  <BasicCard>
    <Title variant='subtitle2'>Produto</Title>
    <Subtitle variant='subtitle2'>{description}</Subtitle>
    <Title variant='subtitle2'>Código do Produto</Title>
    <Subtitle variant='subtitle2'>{productCode}</Subtitle>
    <Title variant='subtitle2'>Id Modelo</Title>
    <Subtitle variant='subtitle2'>{idModel}</Subtitle>
  </BasicCard>
)
